import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  display: flex;
  gap: 20px;
  width: 132px;
`;

export default Wrapper;
